import { render, staticRenderFns } from "./RfxManageCriteria.vue?vue&type=template&id=f838d172"
import script from "./RfxManageCriteria.vue?vue&type=script&lang=js"
export * from "./RfxManageCriteria.vue?vue&type=script&lang=js"
import style0 from "./RfxManageCriteria.vue?vue&type=style&index=0&id=f838d172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports